import React, { useEffect, useState } from "react";
import { CalendarBlockParams } from "./CalendarBlockParams.csharp";
import { CalendarItemBlockParams } from "../CalendarItemBlock/CalendarItemBlockParams.csharp";
import classNames from "classnames";
import { CalendarDayEventBlockList } from "../CalendarDayEventBlock/CalendarDayEventBlockList";
import { CalendarBlockLegend } from "./CalendarBlockLegend";

export const CalendarBlockTabsView: React.FC<CalendarBlockParams> = ({
  title,
  body,
  whiteBackground,
  items,
  subheading,
  notFullAnnotation,
  fullAnnotation,
  useH3SizeTitle,
  loadInCollapsedState,
  showFullHeading,
  hideSubheading,
  hideAnnotations
}) => {
  const [activeItem, setActiveItem] = useState<CalendarItemBlockParams | null>(
    null
  );

  const maxHeadingLength = showFullHeading ? 100 : 3;

  useEffect(() => {
    if (items && items.length > 0) {
      setActiveItem(items[0]);
    }
  }, []);

  const buttonOnClick = (selectedItem: CalendarItemBlockParams) => {
    setActiveItem(selectedItem);
  };

  return (
    <details
      className={classNames("details no-margin-mobile", {
        "theme-inherit-light": !whiteBackground,
      })}
      open={!loadInCollapsedState}
    >
      <summary
        className={classNames(
          "details__summary py-2 mb-0",
          { 'px-2': !whiteBackground },
          { h3: useH3SizeTitle },
          { h4: !useH3SizeTitle }
        )}
      >
        {title}
      </summary>
      <div className={classNames('py-2', {
        "px-2": !whiteBackground,
      })}>
        {!!body && (
          <div className="mb-2" dangerouslySetInnerHTML={{ __html: body }} />
        )}
        {!hideSubheading && (
          <h3 className="h4 theme-border pb-1 mb-1">
            {subheading ?? "Timeplan"}
          </h3>
        )}
        <div className="mini-tabs mb-1">
          {items.map((calendarItemBlock, index) => (
            <button
              key={index}
              className={classNames("btn tab", {
                active: activeItem == calendarItemBlock,
              })}
              onClick={() => buttonOnClick(calendarItemBlock)}
            >
              {calendarItemBlock.heading.length > maxHeadingLength && (
                <abbr title={calendarItemBlock.heading}>
                  {calendarItemBlock.heading.substring(0, 3)}
                </abbr>
              )}
              {calendarItemBlock.heading.length <= maxHeadingLength &&
                calendarItemBlock.heading}
            </button>
          ))}
        </div>
        {!hideAnnotations && <CalendarBlockLegend size="small" fullAnnotation={fullAnnotation} notFullAnnotation={notFullAnnotation} onWhiteBg={whiteBackground} />}
        {activeItem && (
          <CalendarDayEventBlockList items={activeItem.dayEvents} itemsWhiteBg={!whiteBackground} />
        )}
      </div>
    </details>
  );
};
